import { instanceLoggedOrNot } from '../strapiAxios';
import { capture } from '../../services/sentry/capture';
import AxiosError from '../../helpers/errors/axios.error';
import { getAppVersion } from '../../helpers/version';

interface Version {
  needUpdate: boolean;
  lastVersion: string;
  currentVersion: string;
  userAppVersion: string;
}

export const updateAppVersion = async (): Promise<{
  data: { data: { attributes: Version } };
}> => {
  try {
    return await instanceLoggedOrNot.post('/configs/updateVersion', {
      currentVersion: getAppVersion()
    });
  } catch (e) {
    const err = new AxiosError('update version', e);
    capture(err, [
      { key: 'detail', extra: err },
      { key: 'version', extra: getAppVersion() }
    ]);
  }
};
